export default {
    routerName: '部门新增',
    dept: {
        name: '部门名',
        parentDeptName: '父级部门',
        leader: '负责人',
        status: '状态',
        open: '启用',
        close: '停用',
        mobile: '手机号',
        email: '邮箱',
        sortOrder: '排序',
    },
};
